import { optional } from '@vromo/models';
import { createModelSchema, primitive } from 'serializr';
import { observable, makeObservable } from 'mobx';

export class TimeFrame {
    from: number | null = null;
    by: number | null = null;

    constructor() {
        makeObservable(this, {
            from: observable,
            by: observable
        });
    }
}

createModelSchema(TimeFrame, {
    from: optional(primitive()),
    by: optional(primitive())
});
